import React, { useState, useEffect } from "react";
import { ArrowRight, Store } from "lucide-react";
import adminService from "../api/adminService";

export default function DashboardHeader() {
  const [tenantName, setTenantName] = useState(
    () => (typeof window !== "undefined" && localStorage.getItem("tenantName")) || ""
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setTenantName(localStorage.getItem("tenantName") || "");
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("tenantUpdated", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("tenantUpdated", handleStorageChange);
    };
  }, []);

  const [ctaConfig, setCtaConfig] = useState({
    cta_banner_title: "Selamat Datang di ASA Link",
    cta_banner_description:
      "Solusi digital untuk mendukung manajemen usaha Anda, dirancang untuk menyederhanakan operasional dan meningkatkan kontrol bisnis.",
    cta_button_text: "Lihat Panduan",
    cta_button_link: "https://asalink.id",
  });

  useEffect(() => {
    const fetchCtaConfig = async () => {
      try {
        // Load from cache first
        const cached = localStorage.getItem("cta_configs_cache");
        if (cached) {
          setCtaConfig((prev) => ({ ...prev, ...JSON.parse(cached) }));
        }

        const res = await adminService.configs.getPublic();
        if (res?.data || res) {
          const data = res.data || res;
          const merged = {
            cta_banner_title:
              data.cta_banner_title || "Selamat Datang di ASA Link",
            cta_banner_description:
              data.cta_banner_description ||
              "Solusi digital untuk mendukung manajemen usaha Anda, dirancang untuk menyederhanakan operasional dan meningkatkan kontrol bisnis.",
            cta_button_text: data.cta_button_text || "Lihat Panduan",
            cta_button_link: data.cta_button_link || "https://asalink.id",
          };
          setCtaConfig(merged);
          localStorage.setItem("cta_configs_cache", JSON.stringify(merged));
        }
      } catch (err) {
        console.error("Gagal memuat konfigurasi CTA:", err);
      }
    };
    fetchCtaConfig();
  }, []);

  const handleOpenGuide = () => {
    const link = ctaConfig.cta_button_link || "https://asalink.id";
    if (link && link !== "#") {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="relative overflow-hidden rounded-2xl h-full bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-800 text-white shadow-lg shadow-teal-900/10">
      {/* Decorative grid pattern (CSS only, no animation) */}
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
      {/* Soft static glow */}
      <div className="absolute -top-24 -right-16 w-72 h-72 bg-emerald-300/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-10 w-64 h-64 bg-teal-300/15 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 p-7 lg:p-8 flex flex-col justify-between h-full gap-6">
        <div className="max-w-2xl">
          {tenantName && (
            <div className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-white/15 border border-white/20 backdrop-blur-sm text-[11px] font-medium text-white/95 mb-4">
              <Store className="w-3 h-3" />
              <span className="truncate max-w-[200px]">{tenantName}</span>
            </div>
          )}
          <h1 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2 leading-tight">
            {ctaConfig.cta_banner_title}
          </h1>
          <p className="text-teal-50/90 text-sm lg:text-[15px] leading-relaxed max-w-lg">
            {ctaConfig.cta_banner_description}
          </p>
        </div>

        <div className="flex items-center justify-between gap-4">
          <button
            type="button"
            onClick={handleOpenGuide}
            className="inline-flex items-center gap-2 bg-white text-teal-700 hover:bg-teal-50 px-5 py-2.5 rounded-lg transition-colors font-semibold text-sm shadow-md shadow-teal-900/10 cursor-pointer">
            {ctaConfig.cta_button_text}
            <ArrowRight className="w-4 h-4" />
          </button>

          {/* Decorative POS icon (inline SVG, lightweight) */}
          <div className="hidden sm:flex items-center justify-center w-20 h-20 lg:w-24 lg:h-24 rounded-2xl bg-white/10 border border-white/15 backdrop-blur-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 lg:w-12 lg:h-12 text-white/90"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M3 10h18" />
              <path d="M7 14h2" />
              <path d="M11 14h2" />
              <path d="M15 14h2" />
              <path d="M7 17h6" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
